/**
 * Init Tab.
 * @param {HTMLElement} rootElement - The root element.
 * @return {void}
 *
 */
function initTab( rootElement ) {
	const tabs = rootElement.querySelectorAll( '[role="tab"]' );
	const tabPanel = rootElement?.parentElement?.parentElement?.nextElementSibling;
	const tabPanels = tabPanel?.querySelectorAll( '[role="tabpanel"]' );
	const tabBackground = rootElement?.parentElement?.parentElement?.parentElement?.previousElementSibling;
	const tabBackgrounds = tabBackground?.querySelectorAll( '[role="tabBackground"]' );

	if ( ! tabPanels ) {
		return;
	}

	const activateTabPanel = ( key ) => {
		tabPanels.forEach( ( el ) => {
			const tabPanelKey = el.dataset.key;
			el?.classList.remove( 'active' );

			if ( tabPanelKey === key ) {
				el?.classList.add( 'active' );
				if ( el?.swiper ) {
					el?.swiper.enable();
					el?.swiper?.scrollbar.updateSize();
				}
			} else if ( el?.swiper ) {
				el?.swiper?.disable();
			}
		} );

		if ( tabBackgrounds ) {
			tabBackgrounds.forEach( ( el ) => {
				const tabBackgroundsKey = el.dataset.key;
				el?.classList.remove( 'active' );

				if ( tabBackgroundsKey === key ) {
					el?.classList.add( 'active' );
				}
			} );
		}
	};

	const setSelectedTab = ( element ) => {
		// Get data attribute key.
		const selectedKey = element.dataset.key;

		tabs.forEach( ( el ) => {
			const key = el.dataset.key;
			if ( key === selectedKey ) {
				el.setAttribute( 'aria-selected', 'true' );
				el.parentElement.classList.add( 'active' );
			} else {
				el.setAttribute( 'aria-selected', 'false' );
				el.parentElement.classList.remove( 'active' );
			}
		} );
		activateTabPanel( selectedKey );
	};

	const handleClick = () => {
		tabs.forEach( ( element ) => {
			element.addEventListener( 'click', function () {
				setSelectedTab( element );
			} );
		} );
	};

	handleClick();

	// Activate first tab.
	setSelectedTab( tabs[ 0 ] );
}

export default initTab;
